import type { PaginatedQueryParams } from 'queries/queries-utils'

export const agentsQueryKeys = {
  get: (params: { teamId: string } & PaginatedQueryParams) =>
    ['agents', params] as const,
  getSummary: (params: { teamId: string }) =>
    ['agents/summary', params] as const
}
